<section class="wizard-panel">
  <div class="wizard-intro">
    <h2>Policy Eligibility Statement</h2>
    <p>
      Please carefully review the following coverage restrictions and limitations. Refer to the actual
      policy for complete coverage details including exclusions and limitations. The policy will
      contain all of the terms and conditions applicable in the event of a loss or claim.
    </p>
    <p>
      The applicant attests that all of the following statements are true, correct and complete to the
      best of his/her knowledge. The applicant also attests that he/she never makes exceptions to any
      of the statements below.
    </p>
  </div>

  @for (section of sections(); track $index) {
    <lib-card [cardTitle]="section.title">
      <div class="statement-html" [innerHTML]="section.body"></div>
    </lib-card>
  }
</section>

<div class="wizard-footer">
  <lib-buttons cssType="btn-primary-outline" size="small" text="← Back" (click)="back.emit()" />
  <lib-buttons size="small" text="Next →" (click)="next.emit()" />
</div>
